import React, { CSSProperties, memo } from 'react';
import isEqual from 'lodash/isEqual';
import { components } from 'react-select';
import AsyncSuggest from 'react-select/async';
import { LOADING_MESSAGE, NO_OPTIONS_MESSAGE } from '../../constants';
import { TMultiSuggestFieldBodyProps } from '../MultiSuggestField.interface';

// eslint-disable-next-line react/display-name
export const MultiSuggestFieldBody = memo(
  (props: TMultiSuggestFieldBodyProps): JSX.Element => {
    const {
      value = null,
      disabled,
      placeholder,
      optionLabelKey,
      optionValueKey,
      search: onSearch,
      isValid,
      customOption,
      onChange,
      ...other
    } = props;

    const componentOption = (props): JSX.Element => {
      const { data, children, ...propsOption } = props;

      return (
        <components.Option {...propsOption}>{customOption ? customOption(children, data) : children}</components.Option>
      );
    };

    const controlStylesHasError = () => (isValid ? {} : { borderColor: '#d9534f' });

    return (
      <AsyncSuggest
        styles={{
          control: (base: CSSProperties) => ({
            ...base,
            ...controlStylesHasError(),
          }),
        }}
        isMulti
        defaultOptions
        value={value}
        isDisabled={disabled}
        placeholder={placeholder}
        getOptionLabel={(option) => option[optionLabelKey]}
        getOptionValue={(option) => option[optionValueKey]}
        defaultValue={value}
        loadOptions={onSearch}
        loadingMessage={() => LOADING_MESSAGE}
        noOptionsMessage={() => NO_OPTIONS_MESSAGE}
        isClearable
        onChange={onChange}
        components={{ Option: componentOption }}
        {...other}
      />
    );
  },
  (prevProps, nextProps) => !(prevProps.disabled !== nextProps.disabled || !isEqual(prevProps.value, nextProps.value)),
);
